import { useFormContext } from 'react-hook-form';
import { FormInputFieldProps, FormSelectField, FormSelectFieldProps, LocalizedText } from '@mews/framework';
import { Stack } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { TagInputField, useEmailValidationContext } from '@mews-commander/form';
import { EnterprisesSelectField } from '@mews-commander/modules/src/modules/enterprises';
import { CommonFormFields } from '../CommonFormFields';
import { FieldNames } from '../FieldNames';
import { useLearningPathsOptions } from '../../hooks/useCommonFormOptions';
import { createListItems } from '../../utils';
import { AddUsersFormValues } from './useAddUsersForm';

export const AddUsersForm = () => {
    const learningPathsOptions = useLearningPathsOptions();

    const { trigger } = useFormContext<AddUsersFormValues>();

    const { invalidEmails } = useEmailValidationContext();

    const handleEmailsChange = async () => {
        await trigger(FieldNames.Emails);
    };

    return (
        <Stack vertical spacing="400">
            <Stack vertical spacing="200">
                <TagInputField
                    {...emailFieldProps}
                    onChange={handleEmailsChange}
                    invalidChips={invalidEmails}
                    delimiters={[
                        UnicodeEntity.Space,
                        UnicodeEntity.Comma,
                        UnicodeEntity.Semicolon,
                        UnicodeEntity.NewLine,
                    ]}
                />

                <FormSelectField {...learningPathFieldProps}>{createListItems(learningPathsOptions)}</FormSelectField>

                <EnterprisesSelectField {...propertiesFieldProps} />
            </Stack>

            <CommonFormFields />
        </Stack>
    );
};

const emailFieldProps = {
    name: FieldNames.Emails,
    label: <LocalizedText textKey={TextKey.EmailAddressPlural} />,
    helper: <LocalizedText textKey={TextKey.EmailAddressPluralHelper} />,
    required: true,
    size: 'medium',
} satisfies FormInputFieldProps;

const propertiesFieldProps = {
    name: FieldNames.EnterpriseIds,
    label: <LocalizedText textKey={TextKey.PortfolioPropertyPlural} />,
    helper: <LocalizedText textKey={TextKey.SelectPropertyHelper} />,
    multiselect: true,
    required: true,
} satisfies Omit<FormSelectFieldProps, 'children'>;

const learningPathFieldProps = {
    name: FieldNames.AssignedLearningPath,
    label: <LocalizedText textKey={TextKey.LearningPath} />,
    helper: <LocalizedText textKey={TextKey.LearningPathHelper} />,
    required: true,
} satisfies Omit<FormSelectFieldProps, 'children'>;
